<xemex-dialog-shell [title]="'deleteUser.title' | translate">
  <div class="p-2">
    @if (resendInviteSuccess) {
      <span>{{ 'resendInvite.successText' | translate }}</span>
    } @else if (resendInviteError) {
      <span>{{ 'resendInvite.errorText' | translate }}</span>
    } @else {
      <span>{{ 'resendInvite.confirmationText' | translate }}</span>
    }
  </div>
  <mat-dialog-actions actions>
    @if (!resendInviteError && !resendInviteSuccess) {
      <xemex-filled-button (click)="onResend()" [disabled]="isResendingInvite">
        <div class="flex">
          <span class="mr-2">{{ 'resendInvite.menuButton' | translate }}</span>
          @if (isResendingInvite) {
            <xemex-spinner size="sm"></xemex-spinner>
          }
        </div>
      </xemex-filled-button>
    }
    @if (!resendInviteError && !resendInviteSuccess) {
      <xemex-outlined-button mat-dialog-close type="button">
        {{ 'general.btnCancel' | translate }}
      </xemex-outlined-button>
    } @else {
      <xemex-filled-button mat-dialog-close class="float-right">
        {{ 'general.btnClose' | translate }}
      </xemex-filled-button>
    }
  </mat-dialog-actions>
</xemex-dialog-shell>
